import Swal from 'sweetalert2';

class DocumentsUserComponent {
    constructor( element ) {
        this.element = element;
        if ( ! this.element ) {
            return;
        }
        this.identify = document.getElementById('identify');
        this.nationality = document.getElementById('nationality');
        this.mother_name = document.getElementById('mother_name');
        this.date_of_birth = document.getElementById('date_of_birth');
        this.genre = document.getElementById('genre');
        this.saveButton = document.getElementById('btnSave');
        this.init();
    }

    init(){
        this.saveButton.addEventListener('click', () => {
            this.saveInfo();
        });
    }

    showMessageErrors(messages){
        let message = '';
        messages.forEach(function ( msg ) {
            message = message + msg + '<br/>';
        });
        Swal.fire({
            type: 'error',
            title: 'Erro',
            html: message
        });
    }

    saveInfo() {
        Swal.fire({
            type: 'info',
            title: 'Aguarde!',
            text: 'Salvando os dados'
        });
        Swal.showLoading();
        const data = {
            'nonce': window.globalVars.nonce,
            'action': 'add_documments_user',
            'genre' : this.genre.value,
            'date_of_birth': this.date_of_birth.value,
            'mother_name': this.mother_name.value,
            'identify': this.identify.value,
            'nationality': this.nationality.value,
            '_wpnonce': window.globalVars.rest_nonce
        };
        jQuery.ajax({
            url: window.location.origin + '/wp-json/documents/v1/update-user-documents',
            type: 'POST',
            data: data,
            dataType: 'JSON',
            success: function( response ) {
                Swal.close();
                if ( response.success ){
                    const url = response.url_redirect;
                    Swal.fire({
                        type: 'success',
                        title: 'Informações gravadas com sucesso. Você será redirecionado para minha conta.',
                        preConfirm: () => {
                            window.location = url;
                            return true;
                        }
                    })
                }else{
                    this.showMessageErrors(response.errors);
                }
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new DocumentsUserComponent( document.querySelector( '[data-component="docs-user-componenent"]' ) );
}, false);


